module.exports = __webpack_public_path__ + "e3bd5750d5caf95c20cac9684825b588.svg";